"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCancel = exports.$axios = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var axios_1 = require("axios");
var axiosInstance_1 = require("./axiosInstance");
Object.defineProperty(exports, "$axios", { enumerable: true, get: function () { return axiosInstance_1.$axios; } });
var errorHandler_1 = require("./handler/errorHandler");
var csrfHandler_1 = require("./handler/csrfHandler");
var requestCancelHandler_1 = require("./handler/requestCancelHandler");
var setHeaders = function (request) {
    request.headers.set("X-Requested-With", "XMLHttpRequest");
    request.headers.set("getUrl", (0, errorHandler_1.getCurrentUrlWithoutContextPath)());
    request.headers.set("CSRFToken", (0, csrfHandler_1.getCSRFToken)());
};
var isCancel = axios_1.default.isCancel;
exports.isCancel = isCancel;
axiosInstance_1.$axios.interceptors.request.use(function (request) {
    setHeaders(request);
    (0, requestCancelHandler_1.handleCancellableRequest)(request);
    return request;
});
axiosInstance_1.$axios.interceptors.response.use(function (response) {
    var _a;
    (0, requestCancelHandler_1.handleCancellableResponse)((_a = response.config) === null || _a === void 0 ? void 0 : _a.cancelToken);
    return response;
}, function (error) {
    var _a;
    if (axios_1.default.isCancel(error)) {
        return Promise.reject(error);
    }
    if (!axios_1.default.isAxiosError(error)) {
        return Promise.reject(error);
    }
    (0, requestCancelHandler_1.handleCancellableResponse)((_a = error.config) === null || _a === void 0 ? void 0 : _a.cancelToken);
    (0, errorHandler_1.handleAuthenticationRedirect)(error);
    (0, errorHandler_1.handleErrorWithRedirect)(error);
    return Promise.reject(error);
});
// handle createAuthRefreshInterceptor refresh response with unauthorized
axiosInstance_1.$axiosRefresh.interceptors.response.use(function (response) { return response; }, function (error) {
    (0, errorHandler_1.handleAuthenticationRedirect)(error);
    return Promise.reject(error);
});
